import styled from 'styled-components'
import { PRIMARY_COLOR } from '../../../../styles/colors.style'
import { breakpoints } from '../../../../constants'

export const BoxPartner = styled.section`
	overflow: hidden;
	margin: 0 auto 40px;
	width: 90%;

	@media screen and (min-width: ${breakpoints.MOBILE}px) {
		width: 72.9%;
	}
`

export const Banner = styled.div`
	.img-responsive {
		max-width: 100%;
		display: block;
		margin: 10px auto;
	}
`

export const Partner = styled.section`
	.intro {
		font-size: 16px;
		font-weight: 100;
		line-height: 30px;
		margin: 30px 0;

		@media screen and (min-width: ${breakpoints.MOBILE}px) {
			font-size: 25px;
			margin: 30px 0 60px;
		}
	}

	.go {
		background: ${PRIMARY_COLOR};
		width: 222px;
		height: 43px;
		color: #fff;
		font-size: 16px;
		line-height: 43px;
		font-weight: 600;
		display: block;
		margin: 0 auto 30px;
		text-align: center;

		.name {
			text-transform: capitalize;
		}
	}

	.box-partner {
		display: flex;
		flex-direction: column;
		align-items: center;

		figure {
			height: 90px;
			max-width: 222px;
			display: flex;
			align-items: center;
			justify-content: center;

			img {
				margin: 0 auto;
				display: block;
				max-width: 100%;
			}
		}

		.partner-list-points {
			text-align: center;
			color: #517abc;
			font-size: 18px;
			font-weight: 600;
			line-height: 30px;
			min-height: 30px;
		}
	}
`

export const Regulation = styled.div`
	.regulation-title {
		color: #517abc;
		font: 100 3.2rem 'Source Sans Pro';
	}

	.regulation-text {
		color: #000;
		font-size: 1.6rem;
		font-weight: 500;
		line-height: 30px;
		margin: 0;
	}
`

export const Pdf = styled.div`
	overflow: auto;
	height: 400px;
	box-shadow: 1px 1px 10px -4px rgba(0, 0, 0, 0.4);
	margin: 20px 0;
	padding: 10px;

	&::-webkit-scrollbar-thumb {
		&:hover {
			background: ${PRIMARY_COLOR};
		}
	}

	ol {
		padding: 0 11px;
		font-size: 1.6rem;

		li {
			text-align: justify;
		}
	}
`
